const mediaQuery = {
  small: '@media screen and (max-width: 959px)',
  medium: '@media screen and (min-width: 960px) and (max-width: 1440px)',
  large: '@media screen and (min-width: 1441px)',
};

export default mediaQuery;
